import { render, staticRenderFns } from "./product-type-select.vue?vue&type=template&id=0ef2a0ad&scoped=true&"
import script from "./product-type-select.vue?vue&type=script&lang=js&"
export * from "./product-type-select.vue?vue&type=script&lang=js&"
import style0 from "./product-type-select.vue?vue&type=style&index=0&id=0ef2a0ad&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef2a0ad",
  null
  
)

export default component.exports